if (!customElements.get('nailnova-photo-gallery')) {
  customElements.define('nailnova-photo-gallery', class extends HTMLElement {
    connectedCallback() {
      if (this.toggleGallery) return;
      const button = this.querySelector('[data-moments-toggle]');
      if (!button) return;
      this.dataset.initialized = 'true';
      button.hidden = false;
      this.toggleGallery = () => {
        const paused = this.dataset.paused !== 'true';
        this.dataset.paused = String(paused);
        button.setAttribute('aria-pressed', String(paused));
        button.setAttribute('aria-label', paused ? button.dataset.playLabel : button.dataset.pauseLabel);
        button.querySelector('[data-moments-control-text]').textContent = paused ? button.dataset.playText : button.dataset.pauseText;
      };
      button.addEventListener('click', this.toggleGallery);
      const prepareImages = () => {
        this.querySelectorAll('img').forEach(image => { image.loading = 'eager'; });
      };
      if ('IntersectionObserver' in window) {
        this.galleryObserver = new IntersectionObserver(entries => {
          const visible = entries[0].isIntersecting;
          this.dataset.visible = String(visible);
          if (visible) prepareImages();
        }, { rootMargin: '200px 0px' });
        this.galleryObserver.observe(this);
      } else {
        this.dataset.visible = 'true';
        prepareImages();
      }
    }
    disconnectedCallback() {
      this.galleryObserver?.disconnect();
      this.querySelector('[data-moments-toggle]')?.removeEventListener('click', this.toggleGallery);
      this.toggleGallery = null;
    }
  });
}
